"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileBrowserContainer = exports.FileGroups = void 0;
const React = __importStar(require("react"));
const resources_1 = require("../model/resources");
const file_browser_display_1 = require("./file-browser-display");
const path_1 = require("../model/path");
const place_selector_1 = require("./place-selector");
const file_browser_modal_1 = require("./file-browser-modal");
const file_browser_context_1 = require("./file-browser-context");
const utilities_1 = require("../utilities");
const result_1 = require("../model/result");
const react_bootstrap_1 = require("react-bootstrap");
const local_files_launcher_1 = require("./local-files-launcher");
const upload_pane_1 = require("./upload-pane");
const loading_wrapper_1 = require("./loading-wrapper");
const cancellable = __importStar(require("../model/cancellable"));
const allGroup = {
    Name: "All",
    FileTypes: ["*"]
};
const forecastGroup = {
    Name: "Forecasts",
    FileTypes: ["Forecast"]
};
exports.FileGroups = {
    All: allGroup,
    Forecasts: forecastGroup
};
/** File browsing UI component.
 * @description If you need a modal UI, it is recommended to use <FileBrowserModal />, or better still PromptForFile() or PromptForFolder()
 */
class FileBrowserContainer extends React.Component {
    constructor(props) {
        super(props);
        this.open = (target) => __awaiter(this, void 0, void 0, function* () {
            let location;
            this.setState({ IsNavigating: true });
            try {
                if (target instanceof path_1.Path) {
                    const resource = yield this.props.FileService.getResource(target);
                    if (resource.Type !== resources_1.ResourceTypes.Folder) {
                        throw new Error(`Cannot open item at '${target.Value}' because it is not a folder.`);
                    }
                    location = resource;
                }
                else {
                    location = target;
                }
                const newResources = this.FilterResources(yield location.GetChildren());
                this.setState({
                    Resources: newResources,
                    Current: location,
                    SelectedResources: file_browser_context_1.IsChooseFolderContext(this.props.Context) && location.Type === resources_1.ResourceTypes.Folder
                        ? [location] // In folder mode, opening a folder always means selecting it too
                        : null // Otherwise, clear selection when opening a location
                });
            }
            catch (error) {
                const description = target instanceof path_1.Path
                    ? target.Value
                    : target.Type === resources_1.ResourceTypes.Folder
                        ? target.Path.Value
                        : target.Name;
                console.error(`Failed to loaded location or its children: '${description}'`, error);
            }
            finally {
                this.setState({ IsNavigating: false });
            }
        });
        this.tryGetSelectedPath = () => {
            const folder = resources_1.FolderOf(this.state.Current);
            if (!folder) {
                return { Success: false, Error: "No folder selected" };
            }
            else if (this.state.SelectedName) {
                return { Success: true, Value: folder.Path.Concat(this.state.SelectedName) };
            }
            else if (this.state.SelectedResources) {
                return { Success: true, Value: this.state.SelectedResources[0].Path };
            }
            else {
                return { Success: false, Error: "No name selected" };
            }
        };
        this.canSubmit = () => {
            switch (this.props.Context.Type) {
                case "SaveFile":
                    return this.tryGetSelectedPath().Success;
                case "MoveToFolder":
                case "OpenFile":
                case "OpenFolder":
                    return !!this.state.SelectedResources;
                default: utilities_1.HandleNever(this.props.Context, "FileBrowserContext.Type");
            }
        };
        const fileGroups = new Array();
        const actualFileGroups = this.props.FileGroups === "All"
            ? [{ Name: "All", FileTypes: ["*"] }]
            : this.props.FileGroups.map(group => ({
                Name: group.Name,
                FileTypes: group.FileTypes.map(type => typeof type === "string" ? type : type.CustomValue)
            }));
        if (actualFileGroups.length === 0) {
            throw new Error("No filegroups supplied to container");
        }
        actualFileGroups.forEach(propFileGroup => {
            fileGroups.push(propFileGroup);
        });
        this.state = {
            Resources: [],
            Current: null,
            SelectedResources: null,
            SelectedName: null,
            SelectedFileGroup: actualFileGroups[0],
            Notification: null,
            FileGroups: fileGroups,
            TempFolder: null,
            OngoingUploads: [],
            IsNavigating: false
        };
        // Asynchronously check for existence of temp folder
        // If it exists, we can show the LocalFileLauncher
        this.TryGetTempFolder().then(result => {
            if (result.Success) {
                this.setState({
                    TempFolder: result.Value
                });
            }
            else {
                this.setState({
                    Notification: {
                        Type: "Alert",
                        Message: result.Error
                    }
                });
            }
        });
        // Asynchronously attempt to get archive folder
        // So we can check if current folder is within the archive
        props.FileService.getPlaces()
            .then(places => {
            const archivePlace = places.find(place => place.PlaceType === "MyArchive");
            if ((archivePlace === null || archivePlace === void 0 ? void 0 : archivePlace.Type) === resources_1.ResourceTypes.Folder) {
                this.setState({ Archive: archivePlace });
            }
        }, error => {
            console.error(`Failed to fetch places. Unable to find Archive place. ${error}`);
        });
    }
    TryGetTempFolder() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const places = yield this.props.FileService.getPlaces();
                const tempPlace = places.find(place => place.Name === "Temp");
                return tempPlace && tempPlace.Type === resources_1.ResourceTypes.Folder
                    ? result_1.Pass(tempPlace.Path)
                    : result_1.Pass(null);
            }
            catch (error) {
                return result_1.Fail("Failed to retrieve Places.");
            }
        });
    }
    FilterResources(resources) {
        if (file_browser_context_1.IsChooseFolderContext(this.props.Context)) {
            return resources.filter(resource => resource.Type === resources_1.ResourceTypes.Folder);
        }
        else {
            if (this.state.SelectedFileGroup.FileTypes.includes("*")) {
                return resources;
            }
            else {
                return resources.filter(resource => {
                    switch (resource.Type) {
                        case resources_1.ResourceTypes.Folder:
                            return true;
                        case resources_1.ResourceTypes.Forecast:
                        case resources_1.ResourceTypes.ResourceFile:
                            return this.state.SelectedFileGroup.FileTypes.includes(resource.FileType);
                    }
                });
            }
        }
    }
    isCurrentFolderWithinArchive() {
        const folder = resources_1.FolderOf(this.state.Current);
        return this.state.Archive && folder
            && folder.Path.StartsWith(this.state.Archive.Path);
    }
    componentDidMount() {
        if (this.props.InitialFolder) {
            this.open(this.props.InitialFolder);
        }
        if (this.props.Context.Type === "SaveFile" && this.props.InitialFilename) {
            this.setState({
                SelectedName: this.props.InitialFilename
            });
        }
    }
    render() {
        const selectResource = (resources, selectionType) => {
            if (resources.length > 1) {
                this.setState({
                    SelectedResources: resources,
                    SelectedName: null
                });
            }
            else {
                // single resource behaviour
                const selectedResource = resources[0];
                if (selectedResource) {
                    if (this.props.Context.Type === "OpenFile" || this.props.Context.Type === "SaveFile") {
                        if (selectedResource.Type !== resources_1.ResourceTypes.Folder) {
                            if (selectionType === "Emphatic") {
                                this.props.Context.Type === "OpenFile"
                                    ? this.props.Context.OnSubmit(selectedResource)
                                    : this.props.Context.OnSubmit(selectedResource.Path);
                            }
                            else {
                                this.setState({
                                    SelectedResources: [selectedResource],
                                    SelectedName: null
                                });
                            }
                        }
                        else if (selectionType === "Emphatic") {
                            this.open(selectedResource);
                        }
                    }
                    else if (file_browser_context_1.IsChooseFolderContext(this.props.Context) && selectedResource.Type === resources_1.ResourceTypes.Folder) {
                        if (selectionType === "Emphatic") {
                            this.props.Context.OnSubmit(selectedResource);
                        }
                        else {
                            this.setState({
                                SelectedResources: [selectedResource],
                                SelectedName: null
                            });
                        }
                    }
                }
            }
        };
        const setPlace = (inputPlace) => {
            if (inputPlace.Type === resources_1.ResourceTypes.Folder) {
                this.open(inputPlace.Path);
            }
            else {
                this.open(inputPlace);
            }
        };
        const inputRowHeight = 64;
        const floatOverTableStyle = {
            position: "absolute",
            left: "16px",
            bottom: `${inputRowHeight}px`
        };
        const onSubmit = () => {
            if (this.props.Context.Type === "SaveFile") {
                const selectedPath = this.tryGetSelectedPath();
                if (selectedPath.Success) {
                    this.props.Context.OnSubmit(selectedPath.Value);
                }
            }
            else if (this.state.SelectedResources) {
                this.props.Context.OnSubmit(this.state.SelectedResources[0]);
            }
        };
        const handleSelectFileGroup = (optionSelected) => {
            const matchingGroup = this.state.FileGroups.find(group => group.Name === optionSelected);
            if (matchingGroup) {
                this.setState({
                    SelectedFileGroup: matchingGroup
                });
                if (this.state.Current) {
                    this.open(this.state.Current);
                }
            }
        };
        const raiseAlert = message => {
            this.setState({ Notification: {
                    Type: "Alert",
                    Message: message,
                } });
        };
        const raiseInfo = message => {
            this.setState({ Notification: {
                    Type: "Info",
                    Message: message,
                } });
        };
        const renderNotification = () => {
            var _a;
            if (this.state.Notification) {
                const notificationClass = (((_a = this.state.Notification) === null || _a === void 0 ? void 0 : _a.Type) == "Alert") ? "alert alert-danger alert-dismissible" : "alert alert-info alert-dismissible";
                return React.createElement("div", { className: notificationClass, style: floatOverTableStyle, role: "alert" },
                    this.state.Notification.Message,
                    React.createElement("button", { type: "button", className: "close", "aria-label": "Close" },
                        React.createElement("span", { "aria-hidden": "true", onClick: () => this.setState({ Notification: null }) }, "\u00D7")));
            }
            return React.createElement("div", null);
        };
        const submitTempFile = (resource) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.props.Context.Type === "OpenFile") {
                    this.props.Context.OnSubmit(resource);
                }
            }
            catch (error) {
                raiseAlert(`Error getting temporary file ${resource.Id} - ${error}`);
            }
        });
        const uploadFile = (file) => __awaiter(this, void 0, void 0, function* () {
            const targetFolder = resources_1.FolderOf(this.state.Current);
            if (targetFolder) {
                if (this.state.OngoingUploads.length >= 5) {
                    return cancellable.Failed("Please wait for current uploads to finish.");
                }
                // Start upload
                const newUpload = this.props.FileService.uploadResource(targetFolder.Path, file);
                // Add upload to ongoing uploads, remove when done
                this.setState({ OngoingUploads: [...this.state.OngoingUploads, newUpload] });
                newUpload.Complete.finally(() => this.setState({ OngoingUploads: this.state.OngoingUploads.filter(upload => upload !== newUpload) }));
                // Wait for upload to complete before refreshing folder
                newUpload.Complete.then(() => {
                    var _a;
                    // Only refresh if the target folder is still in view
                    if ((_a = resources_1.FolderOf(this.state.Current)) === null || _a === void 0 ? void 0 : _a.Path.Equals(targetFolder.Path)) {
                        this.open(targetFolder);
                    }
                });
                return newUpload.Complete;
            }
            else {
                return cancellable.Failed("No folder selected");
            }
        });
        const okText = this.props.OkText || GetDefaultOkText(this.props.Context);
        const containerStyles = Object.assign(Object.assign({}, this.props.style), { display: 'flex', flexDirection: 'column' });
        return (React.createElement(loading_wrapper_1.LoadingWrapper, { isLoading: this.state.IsNavigating, className: "file-browser file-browser-bootstrap", style: containerStyles },
            React.createElement("div", { className: "d-flex flex-grow-1 border-bottom no-select" },
                React.createElement("div", { className: "border-right", style: { height: "100%", padding: "16px", minWidth: "12em" }, key: "PlacesPane" },
                    React.createElement(place_selector_1.PlaceSelector, { FileService: this.props.FileService, SelectPlace: setPlace, RaiseAlert: raiseAlert, ShowTemp: false }),
                    // Allow selection of local files if context is appropriate and there's
                    // a temp folder to upload them to
                    this.props.Context.Type === "OpenFile" && !!this.state.TempFolder && this.props.ShowMyComputer &&
                        (React.createElement("div", null,
                            React.createElement("hr", null),
                            React.createElement(local_files_launcher_1.LocalFilesLauncher, { FileService: this.props.FileService, TempFolder: this.state.TempFolder, OnSubmit: submitTempFile, RaiseAlert: raiseAlert })))),
                React.createElement("div", { className: "flex-grow-1", style: { height: "100%" }, key: "ContentsPane" },
                    React.createElement(file_browser_display_1.FileBrowserDisplay, { Context: this.props.Context, Resources: this.state.Resources, Open: this.open, Current: this.state.Current, SelectResources: selectResource, SelectedResources: this.state.SelectedResources, PromptForFolder: (resourcesToMove, initialFolder) => file_browser_modal_1.PromptForFolder({
                            Context: { Type: "MoveToFolder", ItemsToMove: resourcesToMove },
                            InitialFolder: initialFolder,
                            FileService: this.props.FileService,
                        }), CreateFolder: path => this.props.FileService.createFolder(path), RaiseAlert: raiseAlert, RaiseInfo: raiseInfo, UploadFile: uploadFile, ShowHorizontalToolbar: !this.props.HideHorizontalToolbar, 
                        // Don't show Upload for archive folder
                        ShowUploadOption: !this.props.HideUploadOption && !this.isCurrentFolderWithinArchive() }))),
            React.createElement("div", { id: "progress" },
                React.createElement(upload_pane_1.UploadPane, { Uploads: this.state.OngoingUploads })),
            React.createElement("div", { className: "input-row no-select", style: { height: `${inputRowHeight}px` } },
                React.createElement("div", { className: "d-flex", style: { flexDirection: "row" } },
                    (!file_browser_context_1.IsChooseFolderContext(this.props.Context)) &&
                        (React.createElement(react_bootstrap_1.Dropdown, null,
                            React.createElement(react_bootstrap_1.Dropdown.Toggle, { id: "dropdown-basic", variant: "light", size: "sm", style: { width: "7em" } }, this.state.SelectedFileGroup.Name),
                            React.createElement(react_bootstrap_1.Dropdown.Menu, null, this.state.FileGroups.map(group => {
                                return React.createElement(react_bootstrap_1.Dropdown.Item, { key: group.Name, eventKey: group.Name, onSelect: handleSelectFileGroup }, group.Name);
                            })))),
                    React.createElement("input", { className: "form-control form-control-sm flex-grow-1", value: this.state.SelectedName
                            ? this.state.SelectedName
                            : this.state.SelectedResources
                                ? this.state.SelectedResources[0].Path.Value
                                : "", onChange: e => this.setState({ SelectedName: e.target.value, SelectedResources: null }), readOnly: this.props.Context.Type !== "SaveFile" }),
                    React.createElement("button", { disabled: !this.canSubmit(), onClick: onSubmit, className: "btn btn-light btn-sm" }, okText),
                    React.createElement("button", { onClick: this.props.Cancel, className: "btn btn-light btn-sm" }, "Cancel"))),
            renderNotification()));
    }
}
exports.FileBrowserContainer = FileBrowserContainer;
function GetDefaultOkText(context) {
    switch (context.Type) {
        case "OpenFile":
        case "OpenFolder":
            return "Open";
        case "SaveFile": return "Save";
        case "MoveToFolder": return "Select";
        default: utilities_1.HandleNever(context, "FileBrowserContext.Type");
    }
}
class DummyUpload {
    constructor(Name, CurrentProgress) {
        this.Name = Name;
        this.CurrentProgress = CurrentProgress;
        this.Complete = new Promise(() => { });
    }
    OnProgress(handler) {
    }
    Cancel() {
        alert(`Upload of ${this.Name} cancelled`);
    }
}
//# sourceMappingURL=file-browser-container.js.map